// Import the toast function from the use-toast component
import { toast as componentToast, useToast } from '../components/ui/use-toast';

// Types
interface ToastProps {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive' | 'success';
}

/**
 * A toast function that can be used outside of React components.
 * This will attempt to use the global toast function but falls back 
 * to console messages if the toast context isn't available.
 */
export const toast = (props: ToastProps) => {
  try {
    // Try to use the component toast function
    componentToast(props);
  } catch (error) {
    // Fallback to console if toast context isn't available
  
  }
};

// Also export the hook for components that want to use it directly
export { useToast }; 